import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerCalendarWorkingHoursWeekly, {
	WholeWeekValues,
} from './ManagerCalendarWorkingHoursWeekly';

interface Props extends BaseModalProps {
	onSubmit: (values: WholeWeekValues) => void;
}

const ManagerCalendarWorkingHoursWeeklyModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.managerCalendarWorkingHoursWeekly.setupWholeWeek'>
			<ManagerCalendarWorkingHoursWeekly onSubmit={props.onSubmit} />
		</BaseModal>
	);
};

export default ManagerCalendarWorkingHoursWeeklyModal;
